<template>
  <div class="page-container">
    <el-form
      :model="mediaModel"
      label-width="110px"
      label-position="left"
      class="form-in-dialog"
    >
      <div class="media-row">
        <el-form-item label="素材">
          <div v-if="mediaModel.mediaId" class="img-container">
            <el-image fit="contain" :src="mediaModel.mediaIcon" style="display: block" />
            <div class="img-mask">
              <el-button type="primary" plain @click="showCreativeCentre = true"
                >从素材库选择</el-button
              >
            </div>
          </div>
          <div v-else class="media-container" @click="showCreativeCentre = true">
            <i class="el-icon el-icon-picture-outline"> 从素材库选择</i>
          </div>
        </el-form-item>
        <div v-if="mediaModel.mediaId" :span="12" class="media-right-item">
          <el-form-item label="素材ID">{{ mediaModel.mediaId }}</el-form-item>
          <el-form-item label="素材名称">{{ mediaModel.mediaName }}</el-form-item>
          <el-form-item label="素材类型">{{
            mediaModel.adMediaClass.mediaClassName
          }}</el-form-item>
          <el-form-item label="素材状态">
            <i
              class="dot"
              :style="{ backgroundColor: statusColors[mediaModel.checkStatus] }"
            ></i>
            <span>{{ $consts.materialStatisText[mediaModel.checkStatus] }}</span>
            <span
              v-if="mediaModel.checkStatus !== 4"
              style="padding-left: 10px; color: #999"
              >(审核且测试通过后，计划单才可生效)</span
            >
          </el-form-item>
          <el-form-item label="广告主">{{ mediaModel.partnerName }}</el-form-item>
          <el-form-item label="广告位">{{ mediaModel.adSpaceName }}</el-form-item>
        </div>
      </div>
      <el-row>
        <el-col :span="22" style="display: flex; gap: 40px">
          <el-form-item v-if="mediaModel.minIcon" label="封面图">
            <el-image
              cover
              style="width: 300px; background-color: #3e649a"
              :src="mediaModel.minIcon"
              :preview-src-list="[mediaModel.minIcon]"
            ></el-image>
          </el-form-item>
          <el-form-item v-if="mediaModel.bgIcon" label="背景图" label-width="70px">
            <el-image
              cover
              style="width: 300px; background-color: #3e649a"
              :src="mediaModel.bgIcon"
              :preview-src-list="[mediaModel.bgIcon]"
            ></el-image>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="22">
          <el-form-item label="显示时长">
            <template v-if="mediaModel.mediaClassId === 1 && !durationDisabled">
              <el-input-number
                v-model="mediaModel.duration"
                controls-position="right"
                :disabled="durationDisabled || true"
                :min="adSpaceModel.duratMinint"
                :max="adSpaceModel.duratMaxint"
              ></el-input-number
              >&nbsp; 秒
              <div class="remark-tip">
                请输入{{ adSpaceModel.duratMinint }}到{{ adSpaceModel.duratMaxint }}的数
              </div>
            </template>
            <span v-else>{{ mediaModel.duration || '-' }} 秒</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="showTargetEvent && !isHomeRecommendationSpace">
        <el-col :span="22">
          <el-form-item label="交互事件">
            <el-radio-group v-model="mediaModel.shipType" @change="handleShipTypeChange">
              <el-radio-button label="NONE">无</el-radio-button>
              <el-radio-button
                v-for="event in eventOptions"
                :key="event.shipType"
                :label="event.shipType"
                >{{ event.name }}</el-radio-button
              >
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="mediaModel.shipType !== 'NONE'">
            <div class="event-wrapper">
              <TargetEventItem
                :partnerId="scheduleForm.partnerId"
                :ship-type="mediaModel.shipType"
                :model="mediaModel.targetEvent"
                :eventTempList="eventTempList"
                @temp-change="handleTargetEventChange"
              />
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="!isHomeRecommendationSpace">
        <el-col :span="22">
          <el-form-item label="提示语">
            <AdTipsEditorNew
              ref="tipsEditor"
              :tipsTempId="mediaModel.tipsTempId"
              :tipsDetail="mediaModel.tipsDetail"
              :spaceId="scheduleForm.spaceId"
              :targetEventType="mediaModel.targetEventType"
              @change-tips="saveTips"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="!isHomeRecommendationSpace">
        <el-col :span="22">
          <el-form-item label="监测代码">
            <el-tabs value="click" type="border-card" style="padding: 0">
              <el-tab-pane label="点击监测" name="click">
                <MediaTrack
                  trackKey="track_click"
                  :trackTypeList="trackTypeList"
                  :providerList="providerList"
                  :sdkProviderList="sdkProviderList"
                  :trackList="mediaModel.clickTrackList"
                ></MediaTrack>
              </el-tab-pane>
            </el-tabs>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <CommonUploadTable
      v-model="showCreativeCentre"
      :mediaQuery="{
        checkStatusArray: [1, 2, 4],
        mediaClassId: isHomeRecommendationSpace ? 2 : undefined
      }"
      :mediaList="unionMediaList"
      :orderScheduleForm="scheduleForm"
      @selected-media="handleSelectedMedia"
    />
  </div>
</template>

<script>
import CommonUploadTable from '@/components/CommonUploadTable.vue'
import AdTipsEditorNew from '@/components/media/AdTipsEditorNew.vue'
import TargetEventItem from '@/components/targetEvent/TargetEventItem.vue'
import { eventOptions, genTargetEvent } from './MaterialCreative'
import MediaTrack from '@/components/MediaTrack.vue'

export default {
  components: {
    CommonUploadTable,
    AdTipsEditorNew,
    TargetEventItem,
    MediaTrack
  },
  inject: [
    'adSpaceModel',
    'scheduleForm',
    'spaceTipsTempId',
    'spaceTipsDetail',
    'eventTempList',
    'providerList',
    'sdkProviderList'
  ],
  props: {
    mediaModel: {
      type: Object,
      default: () => ({})
    },
    unionMediaList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      showCreativeCentre: false,
      eventOptions,
      statusColors: ['', '', '', '', '', '', '']
    }
  },
  computed: {
    durationDisabled() {
      return this.adSpaceModel.durationint === 0 || this.mediaModel.mediaClassId !== 1
    },
    showTargetEvent() {
      return this.adSpaceModel.targetEvent === 1
    },
    isHomeRecommendationSpace() {
      return this.adSpaceModel.spaceNo === 'CCADTV10016'
    },
    trackTypeList() {
      return this.adSpaceModel.trackTypeList
        ? JSON.parse(this.adSpaceModel.trackTypeList)
        : []
    }
  },
  created() {
    this.statusColors = this.$consts.materialStatusOptions.map((item) => item.color)
  },
  methods: {
    handleShipTypeChange(val) {
      if (val === 'NONE') {
        this.mediaModel.targetEvent = genTargetEvent()
        this.handleTargetEventChange(4)
      }
      this.mediaModel.clickButtonContent = ''
    },
    handleTargetEventChange(targetEventType) {
      this.mediaModel.targetEventType = targetEventType
      if (this.mediaModel.tipsTempId === undefined && this.mediaModel.tipsDetail) {
        this.$alert('由于交互事件类型变更，提示语将清空，请重新设置', '提示', {
          confirmButtonText: '确定',
          callback: (action) => {
            this.mediaModel.tipsTempId = undefined
            this.mediaModel.tipsDetail = ''
          }
        })
      }
    },
    saveTips(data) {
      this.mediaModel.tipsTempId = data.tipsTempId
      this.mediaModel.tipsDetail = data.tipsDetail
    },
    handleSelectedMedia(rowData) {
      if (!rowData.mediaDetailList || rowData.mediaDetailList.length === 0) {
        return this.$message.error('选择的素材异常')
      }
      if (
        this.adSpaceModel.brandIcon === 1 &&
        rowData.mediaClassId === 2 &&
        !rowData.minIcon
      ) {
        return this.$message.error(
          '所选广告位素材必须添加封面图才可以投放，建议您前往【素材库】编辑素材添加该内容'
        )
      }
      const row = rowData.mediaDetailList[0]
      let media = this.mediaModel
      media.mediaName = rowData.mediaName
      media.spaceId = rowData.spaceId
      media.partnerName = rowData.adDspPartner.partnerName
      media.adSpaceName = rowData.adSpace.spaceName
      media.adMediaClass.mediaClassName = rowData.adMediaClass.mediaClassName
      media.mediaId = rowData.mediaId
      media.mediaClassId = rowData.mediaClassId
      media.md5 = rowData.md5
      media.checkStatus = rowData.checkStatus
      media.materialId = 0
      media.materialName = rowData.mediaName
      media.minIcon = rowData.minIcon
      if (row.duration) {
        media.duration = row.duration
      }
      media.mediaIcon = rowData.mediaIcon
      this.showCreativeCentre = false
    }
  }
}
</script>

<style lang="stylus" src="./materialOwnSource.styl" scoped></style>
